import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { initThemeFromStorage } from './utils/themePreference';
import App from './App';
import reportWebVitals from './reportWebVitals';

initThemeFromStorage();

/* Suppress harmless errors: ResizeObserver loop, MetaMask extension */
const isResizeObserverError = (msg) => {
  const s = (msg && String(msg)) || '';
  return s.includes('ResizeObserver loop');
};
const isMetaMaskError = (msg, err) => {
  const s = (msg && String(msg)) || '';
  const m = (err?.message && String(err.message)) || '';
  const stack = (err?.stack && String(err.stack)) || '';
  return s.includes('MetaMask') || s.includes('Failed to connect') ||
         m.includes('MetaMask') || m.includes('Failed to connect') ||
         stack.includes('nkbihfbeogaeaoehlefnkodbefgpgknn'); /* MetaMask extension ID */
};
const _origOnError = window.onerror;
window.onerror = function (msg, url, line, col, error) {
  if (isResizeObserverError(msg)) return true;
  if (isMetaMaskError(msg, error)) return true;
  if (url && String(url).includes('nkbihfbeogaeaoehlefnkodbefgpgknn')) return true;
  return _origOnError ? _origOnError.apply(this, arguments) : false;
};
// Prevent ResizeObserver error from reaching React's error overlay (capture phase runs first)
window.addEventListener('error', (e) => {
  if (isResizeObserverError(e?.message)) {
    e.stopImmediatePropagation();
    if (e.cancelable) e.preventDefault();
    // Fallback: hide overlay if it already appeared
    requestAnimationFrame(() => {
      const overlay = document.getElementById('webpack-dev-server-client-overlay');
      const overlayDiv = document.getElementById('webpack-dev-server-client-overlay-div');
      if (overlay) overlay.style.display = 'none';
      if (overlayDiv) overlayDiv.style.display = 'none';
    });
    return true;
  }
}, true);
window.addEventListener('unhandledrejection', (e) => {
  const reason = e?.reason;
  const msg = reason?.message || String(reason || '');
  const stack = reason?.stack || '';
  if (msg.includes('MetaMask') || msg.includes('Failed to connect') ||
      stack.includes('nkbihfbeogaeaoehlefnkodbefgpgknn')) {
    e.preventDefault();
    e.stopPropagation();
    return false;
  }
}, true);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
